<template>
  <a :href="url" target="_blank" class="nav-item external-link">
    <fluent-icon :icon="icon" />
  </a>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.external-link {
  display: flex;
  align-items: center;
  padding: var(--space-medium) var(--space-small);
  text-decoration: none;
  color: inherit;
}

.external-link:hover {
  background-color: var(--s-50);
}
</style>